import { useEffect, useRef, useState } from 'react';
import { getUserPathwaysAPI } from './utils/profilePathways';

export function useProfilePathways(username: string) {
  const hasFetchedData = useRef(false);

  const [userPathways, setUserPathways] = useState([]);
  const [userPathwaysLoaded, setUserPathwaysLoaded] = useState(false);

  useEffect(() => {
    if (!hasFetchedData.current) {
      getUserPathwaysAPI(username, userPathwaysCallback);
      hasFetchedData.current = true;
    }
  }, []);

  const userPathwaysCallback = (data) => {
    setUserPathways(data);
    setUserPathwaysLoaded(true);
  };

  return [userPathways, userPathwaysLoaded];
}
